import { render, staticRenderFns } from "./VademecumGrupo.vue?vue&type=template&id=7ff53a7a&scoped=true&"
import script from "./VademecumGrupo.vue?vue&type=script&lang=js&"
export * from "./VademecumGrupo.vue?vue&type=script&lang=js&"
import style0 from "./VademecumGrupo.vue?vue&type=style&index=0&id=7ff53a7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff53a7a",
  null
  
)

export default component.exports